module.exports = __webpack_public_path__ + "img/Extra-8-548x353.e8634c75.jpg";